export default __webpack_public_path__ + "static/img_2_376-2b223b42efdfda07f73bd6109610aa86.jpg";